module.exports = __webpack_public_path__ + "img/vuepress-screenshot.4a593f43.jpg";